<template>
    <div class="dis-flex flex-m product-card-list mb-2 col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 p-lr-0-sm">

        <input class="mr-2 select-product-checkbox dis-block" v-if="selectForDelete" type="checkbox" name="product-to-trash" :id="`thisProduct-${thisProduct.id}`" @change="selectThisProductForDelete($event, thisProduct)">
        <label class="w-full m-0" :for="`thisProduct-${thisProduct.id}`"
            :class="{
                'product-minimize': selectForDelete,
                'op-04': thisProduct.selectedForDelete
            }">
            <div class="card p-3 dis-flex w-full pos-relative">
                <!-- <div class="dis-flex flex-m pos-absolute top-2 ml-1">
                    <i class="fa fa-folder-open text-rose"></i>
                    <span class="text-rose ml-1 mr-1">-</span>
                    <small class="text-rose txt-italic fs-10">Product Group</small>
                </div> -->
                <div class="col-sm-12 p-0">
                    <div class="dis-flex flex-m flex-sb mb-3">
                        <div class="dis-flex flex-m w-full">
                            <i class="fa fa-folder-open text-rose mr-2 multi-popup small-pp" desc="Products Group"></i>
                            <h6 class="mb-0 dis-inline-block font-h-6-name mobile-product-list-card text-back product-header small-header w-full mr-2 text-truncate pos-relative">{{ thisProduct.name[selectedLang] }}</h6>
                        </div>
                        <div class="buttons-whatch-attirute desktop-product-action-buttons ml-3">
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Attributes" v-if="!(thisProduct.selectedProductMenu == 'attributes')" @click="thisProduct.selectedProductMenu = 'attributes'">
                                <i class="uis uis-brightness-plus fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Photos" v-if="!(thisProduct.selectedProductMenu == 'photos')" @click="thisProduct.selectedProductMenu = 'photos'">
                                <i class="uis uis-camera fs-12"></i>
                            </div>
                            <!-- <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Info" v-if="!(thisProduct.selectedProductMenu == 'info')" @click="thisProduct.selectedProductMenu = 'info'">
                                <i class="uis uis-folder-info fs-12"></i>
                            </div> -->
                            <div class="btn small-form-btn bar-code fs-10 pointer m-0" title="Product Overview" @click="$emit('setSelectedProductForOverview', thisProduct.id)">
                                <i class="uis uis-search fs-12"></i>
                            </div>
                        </div>
                        <div class="buttons-whatch-attirute mobile-product-action-buttons ml-3">
                            <template v-if="mobileActionBtnsOpened">
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Attributes" v-if="!(thisProduct.selectedProductMenu == 'attributes')" @click="thisProduct.selectedProductMenu = 'attributes'">
                                    <i class="uis uis-brightness-plus fs-12"></i>
                                </div>
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Show Photos" v-if="!(thisProduct.selectedProductMenu == 'photos')" @click="thisProduct.selectedProductMenu = 'photos'">
                                    <i class="uis uis-camera fs-12"></i>
                                </div>
                                <!-- <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Info" v-if="!(thisProduct.selectedProductMenu == 'info')" @click="thisProduct.selectedProductMenu = 'info'">
                                    <i class="uis uis-folder-info fs-12"></i>
                                </div> -->
                                <div class="btn small-form-btn bar-code fs-10 pointer m-0 mr-3" title="Product Overview" @click="$emit('setSelectedProductForOverview', thisProduct.id)">
                                    <i class="uis uis-search fs-12"></i>
                                </div>
                            </template>
                            
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Actions" v-if="!mobileActionBtnsOpened" @click="mobileActionBtnsOpened = true">
                                <i class="uis uis-ellipsis-h fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Close Actions" v-else @click="mobileActionBtnsOpened = false">
                                <i class="uis uis-multiply fs-12"></i>
                            </div>
                        </div>
                    </div>

                    <div class="photo-grid-row-action-btns w-full flex-r mb-3" :class="{
                            'dis-flex': thisProduct.selectedProductMenu == 'photos'
                        }">
                        <div class="buttons-whatch-attirute">
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Row View" v-if="thisProduct.photoViewType == 'grid'" @click="thisProduct.photoViewType = 'row'">
                                <i class="uis uis-grip-horizontal-line fs-12"></i>
                            </div>
                            <div class="btn small-form-btn bar-code fs-10 mt-0 pointer" title="Grid View" v-else @click="thisProduct.photoViewType = 'grid'">
                                <i class="uis uis-apps fs-12"></i>
                            </div>
                        </div>
                    </div>

                    <div class="dis-flex flex-m">
                        <div class="dis-flex flex-m col-sm-12 p-0">
                            <div class="any-product-photo" v-if="!(thisProduct.selectedProductMenu == 'photos')">
                                <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                <!-- <img src="@/assets/images/product-06.jpg" alt=""> -->
                            </div>
                            <div v-trix-horizontal-slider class="any-product-info-blocks-scroll product-all-photo-rows snap-inline-element-info-product" v-if="thisProduct.selectedProductMenu == 'photos'"
                                :class="{'product-all-photo-grid': thisProduct.photoViewType == 'grid'}">
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                                <div class="any-product-photo client-dashboard">
                                    <img :src="thisProduct.mainPhoto" alt="" draggable="false">
                                </div>
                            </div>

                            <!-- <div v-trix-horizontal-slider class="any-product-info-blocks-scroll snap-inline-element-info-product" v-else-if="thisProduct.selectedProductMenu == 'info'">
                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-left text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-dollar-alt mr-1"></i>Price: -</small>
                                            <h5 class="col-8 text-sm-b text-blue pl-2 pr-0">180,757
                                                <span class="text-sm-d ml-1">€</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-label mr-2"></i>Sku: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0 trix-slider-selector">0055-WTH-HC</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="fa fa-barcode mr-2"></i>Bar: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0 trix-slider-selector">3029383575095</h5>
                                        </div>
                                    </div>
                                </div>

                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-left text-blue pos-absolute rt-1-5r"></i>
                                    <i class="fs-15 uis uis-angle-double-right text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-shopping-bag mr-1"></i>Qty: -</small>
                                            <h5 class="col-8 text-sm-b text-blue pl-2 pr-0">54<small class="text-main-cl fs-12 self-align-en ml-1">Pcs.</small></h5>
                                        </div>
                                        <div class="dis-flex flex-m mb-1">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-building mr-1"></i>Loc: -</small>
                                            <h5 class="col-8 text-sm-b text-blue pl-2 pr-0">1
                                                <span class="text-sm-d ml-1">Warehouse</span>
                                            </h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-store mr-1"></i>Loc: -</small>
                                            <h5 class="col-8 text-sm-b text-blue pl-2 pr-0">4
                                                <span class="text-sm-d ml-1">Shop</span>
                                            </h5>
                                        </div>
                                    </div>
                                </div>

                                <div class="info-product-element dis-flex flex-m text-back client-dashboard pos-relative">
                                    <i class="fs-15 uis uis-angle-double-right text-blue pos-absolute rt-1-1r"></i>
                                    <div class="dis-flex flex-column w-full">
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Size</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Color</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Material</h5>
                                        </div>
                                        <div class="dis-flex flex-m">
                                            <small class="text-main-cl fs-12 self-align-en"><i class="uis uis-brightness-plus mr-1"></i>Attr: -</small>
                                            <h5 class="col-8 text-sm-d pl-2 pr-0">Fur</h5>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                            <div v-trix-horizontal-slider class="any-product-info-blocks-scroll snap-inline-element-info-product product-attribute-overview" v-else-if="thisProduct.selectedProductMenu == 'attributes'">
                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <span class="uim-svg fs-12">
                                            <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                <path class="uim-quaternary-b" style="fill:#069A8E;" d="M9,22H5c-1.65611-0.00181-2.99819-1.34389-3-3V5c0.00181-1.65611,1.34389-2.99819,3-3h4c1.65611,0.00181,2.99819,1.34389,3,3v14C11.99819,20.65611,10.65611,21.99819,9,22z"></path>
                                                <path class="uim-tertiary-g" style="fill:#A1E3D8;"  d="M20.29303,6.53516l-2.82819-2.82819c-1.17249-1.16986-3.07068-1.16986-4.24316,0L11.99341,4.9353C11.9939,4.95734,12,4.97784,12,5v14c0,0.02716-0.00732,0.05231-0.00806,0.07928l8.30109-8.30096C21.46289,9.60583,21.46289,7.70764,20.29303,6.53516z"></path>
                                                <circle cx="7" cy="17" r="1" class="uim-primary"></circle>
                                                <path class="uim-primary-y" style="fill:#FCD900;" d="M19.06476,12.00659l-7.07281,7.07269C11.99268,19.05231,12,19.02716,12,19c-0.00183,1.65613-1.34387,2.99817-3,3h10c1.65613-0.00183,2.99817-1.34387,3-3v-4C21.99817,13.36603,20.69031,12.04364,19.06476,12.00659z"></path>
                                            </svg>
                                        </span>
                                        <span class="text-main-cl fs-11 self-align-en ml-1">Color</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                            <div class="color-attribute" title="Dark Green"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-exclamation fs-15 text-rose m-l--4"></i>
                                        <span class="text-main-cl fs-11 self-align-en">Size</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">XS</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">S</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">L</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">M</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">XXL</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">36</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">37</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">38</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">41</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">42</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                            <div class="created-attribute-components flex-m">
                                                <span class="text-sm-b cl-txt-dark">43</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-camera fs-12 text-rose"></i>
                                        <span class="text-main-cl fs-11 self-align-en ml-1">Material</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                            <div class="photo-attribute" title="100% Cotton"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="dis-flex flex-column h-full">
                                    <div class="text-back small-header mb-1 dis-flex flex-m">
                                        <i class="uis uis-font fs-12 text-rose"></i>
                                        <span class="text-main-cl fs-11 self-align-en ml-1">Weight</span>
                                        <small class="text-rose txt-italic fs-10 self-align-en ml-auto">Attribute</small>
                                    </div>
                                    <div class="info-product-element dis-flex flex-m text-back client-dashboard h-full">
                                        <div class="dis-flex flex-m flex-w fast-attribute-overview">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        thisProduct: {
            type: Object,
            required: true
        },
        selectedLang: {
            type: String,
            required: true
        },
        selectForDelete: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mobileActionBtnsOpened: false,
        }
    },
    methods: {
        selectThisProductForDelete: function(event, thisProdObj) {
            if (event.target.checked) {
                thisProdObj.selectedForDelete = true;
            } else {
                thisProdObj.selectedForDelete = false;
            }
        }
    }
}
</script>

<style>

</style>